// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 72060, offsets 509936:510155. Structure and names inferred from code, not screenshots.

let n = "https://aistudio.xiaomimimo.com/".replace(/\/+$/, ""),
  o = `${n}/open-apis/v1/genLoginUrl`,
  clawLoginUrl = `${o}?currentPath=/?forcePage=claw`,
  chatLoginUrl = `${o}?currentPath=/?forcePage=chat`,
  useMiMoUrl = "https://www.15token.win/dashboard";
export { clawLoginUrl, chatLoginUrl, useMiMoUrl };
